import React, { useState } from "react";
import Image from "next/image";
import HireFromMilesForm from "@/components/forms/hireFromMilesForm";

const LongTermNursingTalentHFM = () => {
  const [isformPopupOpen, setformPopupOpen] = useState(false);

  const openformPopup = () => {
    setformPopupOpen(true);
  };

  const closeformPopup = () => {
    setformPopupOpen(false);
  };
  return (
    <div className="flex flex-col gap-3 w-full relative square_grid_bg">
      <div className="text-center">
        <h2 className="font-bold 2xl:text-[20px] relative inline-block  md:text-[20px] md:leading-[42px] leading-[23px] text-[20px] md:text-black text-center md:mb-1 mt-14">
          <span className="md:mt-1 md:pb-[5px] pb-[5px] leading-[1.1] inline-block text-black">
            Get Reliable, <br />{" "}
            <span className="text-[36px] 2xl:text-[36px] md:text-[36px] border-[#CA7216] leading-[1.1] border-b-[4px] md:pb-[5px] pb-[5px] inline-block text-black">
              Long-term Nursing Talent
            </span>
          </span>
        </h2>
      </div>

      <div className="w-full flex flex-col justify-center items-center mx-auto gap-20 mt-8 mb-20 relative z-20">
        <div className="grid grid-cols-2 w-[70%]">
          <div className="flex justify-end items-start relative">
            <Image
              loading="lazy"
              src="/hire-from-miles/desk-nursing-in-india.png"
              alt="Hire Accountants in India"
              className="mr-40 2xl:mr-24"
              width={364}
              height={364}
            />
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="text-black mt-16 md:font-bold 2xl:text-[24px] md:text-[24px] leading-6">
              Hire Nurses in <span className="text-[#3174d6]">India</span>
            </h3>
            <ul className="list-disc ml-5 text-black 2xl:text-[20px] md:text-[20px] md:leading-6 font-medium leading-7">
              <li>
                Solving your staffing needs quickly with our flexible, <br />
                specialized healthcare workforce
              </li>
              <li>
                Fully trained & specialized, ensuring a smooth
                <br />
                integration to your hospital’s standards
              </li>
              <li>
                Cost-effective staffing solutions without sacrificing <br />
                professional standards
              </li>
            </ul>

            <div className="mt-4 md:block hidden relative ">
              <div className="grp_btn flex md:justify-start items-center ">
                <Image
                  loading="lazy"
                  src="/arrow2.png"
                  alt="arrow image"
                  className="new_arrow mr-1"
                  width={45}
                  height={45}
                  quality={100}
                />
                <div
                  onClick={openformPopup}
                  className="new_btn 2xl:text-[13px] md:text-[13px] md:font-semibold cursor-pointer inline-block !px-10"
                >
                  Know More
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* bottom */}
        <div className="grid grid-cols-2 w-[70%]">
          <div className="w-full flex justify-end">
            <div className="flex flex-col justify-center items-start gap-3">
              <h3 className="text-black md:font-bold 2xl:text-[24px] md:text-[24px] leading-6 mt-12">
                Hire USRNs in the <span className="text-[#FFBA08]">US.</span>
              </h3>
              <ul className="list-disc 2xl:text-[20px] md:text-[20px] md:leading-6 font-medium text-black leading-6">
                <li>
                  Ready-to-deploy talent trained in the US
                  <br />
                  healthcare system
                </li>
                <li>
                  Experienced international nurses with unrestricted
                  <br />
                  RN license
                </li>
                <li>
                  3-year long-term contract with no compliance or
                  <br />
                  payroll hassles, flat bill rate
                </li>
              </ul>
              <div className="mt-4 md:block hidden relative">
                <div className="grp_btn flex md:justify-start items-center">
                  <Image
                    loading="lazy"
                    src="/arrow2.png"
                    alt="arrow image"
                    className="new_arrow"
                    width={45}
                    height={45}
                    quality={100}
                  />
                  <a
                    href="https://www.milestalenthub.com/healthcare"
                    target="_blank"
                    className="new_btn text-center 2xl:text-[13px] md:text-[13px] cursor-pointer md:font-semibold inline-block !px-10"
                  >
                    Know More
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-start items-start relative">
            <Image
              loading="lazy"
              src="/hire-from-miles/desk-nursing-in-us.png"
              alt="US MD program for aspiring doctors in India"
              className="ml-32 2xl:ml-32"
              width={345}
              height={345}
            />
          </div>
        </div>
      </div>

      {isformPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="rounded-[14px] shadow-lg relative lg:w-[500px] lg:h-[auto] md:w-[500px] h-[auto] mx-auto w-[365px] bg-white lg:py-6 lg:px-9 p-4">
            <button
              onClick={closeformPopup}
              className="mt-2 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[0px] z-[9999]"
            >
              ✕
            </button>
            <HireFromMilesForm />
          </div>
        </div>
      )}
    </div>
  );
};

export default LongTermNursingTalentHFM;
